'use strict'
const prod = process.env.VUE_APP_ENV === 'production'
export const baseUrl = {

    // mainProcurement: 'http://192.168.31.100:8086/procurement',
    // mainProcurement: 'http://119.23.51.157:8086/procurement',

    // main: 'http://testxuexiao1.fsytss.com/official' // 本地调试用
    // main: 'https://api.xuexiao.fsytss.com/official',
    // main: 'https://srm.fsytss.com/srm',
    // main: 'http://test.trace.zhongshanyun.cn/trace',

    // main: 'http://172.16.1.33:8891',

    // main: 'http://6uye5q.natappfree.cc',//办公室
    main: prod ? 'https://trace.fsytss.com/trace' : 'http://test.trace.zhongshanyun.cn/trace',//线上



}
export const loginParam = {
    grantType: 'OPENID',
    clientId: 'customer',
    credential: "",
    secret: '73d1c2341636435f8e364f9db552a255',
    username: ''
}
export const uploadUrl = prod ? 'https:://api.xuexiao.fsytss.com/official/v1/file/upload' : 'http://testxuexiao.fsytss.com/official/v1/file/upload'
export const appId = 'wx1adbac727573ad83';
export const appProd = prod;
